import {Map} from "immutable";

export const reportIsFetchingSelector = (state: Map<string, any>) => {
  return state.getIn(["report", "isFetchingData"])
}
export const reportErrorSelector = (state: Map<string, any>) => {
  return state.getIn(["report", "error"])
}


// WEBPACK FOOTER //
// ./src/features/report/store/reportSelectors.js